import { API_CLIENTS_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { ReactElement } from 'react'

interface Props {
  id: string
  onSuccess?: () => void
  children?: () => ReactElement
}

const DeleteApiClientsServiceRequest = ({
  id,
  onSuccess,
  children
}: Props) => {
  const url = `${API_CLIENTS_SERVICE}/api_clients/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='delete'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default DeleteApiClientsServiceRequest
